import { render, staticRenderFns } from "./PairwiseTable.vue?vue&type=template&id=131a508e&lang=pug&"
import script from "./PairwiseTable.vue?vue&type=script&lang=ts&"
export * from "./PairwiseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports